module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "perfectMessage"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue",
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("完善女方信息")]), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("温馨提示：为节省您宝贵的就诊时间且不影响您的诊疗效果，请在就诊前如实完善您的个人信息。")]), _vm._v(" "), _c('group-title', [_vm._v("基本信息")]), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": false
    }
  }, [_c('grid-item', [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "readonly": "",
      "placeholder": "姓名"
    },
    on: {
      "on-change": _vm.iftrim
    },
    model: {
      value: (_vm.basedata.name),
      callback: function($$v) {
        _vm.$set(_vm.basedata, "name", $$v)
      },
      expression: "basedata.name"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nameIcon),
      expression: "nameIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('grid-item', [_c('x-input', {
    attrs: {
      "readonly": "",
      "text-align": "right",
      "placeholder": "性别"
    },
    model: {
      value: (_vm.sex),
      callback: function($$v) {
        _vm.sex = $$v
      },
      expression: "sex"
    }
  })], 1)], 1), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": false
    }
  }, [_c('grid-item', {
    staticClass: "textLeft"
  }, [_c('popup-radio', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "readonly": !_vm.lookIf,
      "placeholder": "民族",
      "text-align": "left",
      "options": _vm.nationOptions
    },
    on: {
      "on-change": _vm.iftrim
    },
    model: {
      value: (_vm.basedata.nationality),
      callback: function($$v) {
        _vm.$set(_vm.basedata, "nationality", $$v)
      },
      expression: "basedata.nationality"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nationalityIcon),
      expression: "nationalityIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('grid-item', [_c('datetime', {
    attrs: {
      "readonly": "",
      "start-date": "1900-01-01",
      "format": "YYYY-MM-DD",
      "placeholder": "出生日期"
    },
    on: {
      "on-change": _vm.iftrim
    },
    model: {
      value: (_vm.basedata.birthday),
      callback: function($$v) {
        _vm.$set(_vm.basedata, "birthday", $$v)
      },
      expression: "basedata.birthday"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.birthdayIcon),
      expression: "birthdayIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": false
    }
  }, [_c('grid-item', [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "placeholder": "电话",
      "keyboard": "number"
    },
    on: {
      "on-change": _vm.telchange
    },
    model: {
      value: (_vm.basedata.phoneNo),
      callback: function($$v) {
        _vm.$set(_vm.basedata, "phoneNo", $$v)
      },
      expression: "basedata.phoneNo"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phoneNoIcon),
      expression: "phoneNoIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('grid-item', [_c('popup-radio', {
    attrs: {
      "readonly": !_vm.lookIf,
      "placeholder": "职业",
      "options": _vm.ZYOptions
    },
    on: {
      "on-change": _vm.iftrim
    },
    model: {
      value: (_vm.basedata.cause),
      callback: function($$v) {
        _vm.$set(_vm.basedata, "cause", $$v)
      },
      expression: "basedata.cause"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.causeIcon),
      expression: "causeIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": false
    }
  }, [_c('grid-item', {
    staticClass: "textLeft"
  }, [_c('popup-radio', {
    attrs: {
      "readonly": _vm.sourceread,
      "placeholder": "来源",
      "options": _vm.HZLYOptions
    },
    on: {
      "on-change": _vm.iftrim
    },
    model: {
      value: (_vm.basedata.source),
      callback: function($$v) {
        _vm.$set(_vm.basedata, "source", $$v)
      },
      expression: "basedata.source"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sourceIcon),
      expression: "sourceIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('grid-item', [_c('popup-radio', {
    attrs: {
      "readonly": !_vm.lookIf,
      "placeholder": "婚姻状况",
      "options": _vm.marriageOptions
    },
    on: {
      "on-change": _vm.iftrim
    },
    model: {
      value: (_vm.basedata.maritalStatus),
      callback: function($$v) {
        _vm.$set(_vm.basedata, "maritalStatus", $$v)
      },
      expression: "basedata.maritalStatus"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.maritalStatusIcon),
      expression: "maritalStatusIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": false
    }
  }, [_c('grid-item', [_c('popup-radio', {
    attrs: {
      "readonly": !_vm.lookIf,
      "title": "文化程度",
      "placeholder": "请选择",
      "options": _vm.whcdOptions
    },
    on: {
      "on-change": _vm.iftrim
    },
    model: {
      value: (_vm.basedata.educationDegree),
      callback: function($$v) {
        _vm.$set(_vm.basedata, "educationDegree", $$v)
      },
      expression: "basedata.educationDegree"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.educationDegreeIcon),
      expression: "educationDegreeIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": false
    }
  }, [_c('grid-item', [_c('cell', {
    attrs: {
      "title": "选择行业",
      "value": _vm.tradeName,
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showPopup = true
      }
    }
  })], 1)], 1), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": false
    }
  }, [_c('grid-item', [_c('popup-radio', {
    attrs: {
      "readonly": !_vm.lookIf,
      "title": "就诊类型",
      "placeholder": "请选择",
      "options": _vm.JZTypeOptions
    },
    on: {
      "on-change": _vm.iftrim
    },
    model: {
      value: (_vm.basedata.seeType),
      callback: function($$v) {
        _vm.$set(_vm.basedata, "seeType", $$v)
      },
      expression: "basedata.seeType"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeTypeIcon),
      expression: "seeTypeIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": false
    }
  }, [_c('grid-item', [_c('popup-radio', {
    attrs: {
      "readonly": _vm.ZJread,
      "title": "证件类型",
      "placeholder": "请选择",
      "options": _vm.ZJTypeOptions
    },
    on: {
      "on-hide": _vm.ZJtypeChange,
      "on-change": _vm.iftrim
    },
    model: {
      value: (_vm.basedata.cardType),
      callback: function($$v) {
        _vm.$set(_vm.basedata, "cardType", $$v)
      },
      expression: "basedata.cardType"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cardTypeIcon),
      expression: "cardTypeIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": false
    }
  }, [_c('grid-item', [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "novalidate": "",
      "show-clear": false,
      "readonly": _vm.ZJread,
      "title": "证件号码",
      "placeholder": "请输入",
      "text-align": "right"
    },
    on: {
      "on-change": _vm.SFZvalidate
    },
    model: {
      value: (_vm.basedata.cardNo),
      callback: function($$v) {
        _vm.$set(_vm.basedata, "cardNo", $$v)
      },
      expression: "basedata.cardNo"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cardNoIcon),
      expression: "cardNoIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": false
    }
  }, [_c('grid-item', [_c('popup-radio', {
    attrs: {
      "readonly": !_vm.lookIf,
      "title": "贫困证明",
      "placeholder": "请选择",
      "options": _vm.familyOptions
    },
    on: {
      "on-change": _vm.iftrim
    },
    model: {
      value: (_vm.basedata.family),
      callback: function($$v) {
        _vm.$set(_vm.basedata, "family", $$v)
      },
      expression: "basedata.family"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.familyIcon),
      expression: "familyIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('group-title', {
    attrs: {
      "id": "adressID"
    }
  }, [_vm._v("现住址")]), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": false
    }
  }, [_c('grid-item', [_c('popup-radio', {
    attrs: {
      "readonly": !_vm.lookIf,
      "title": "省/自治区",
      "placeholder": "请选择",
      "options": _vm.shengOptions
    },
    on: {
      "on-hide": function($event) {
        _vm.addressChange(_vm.shengTxt, 'shiOptions', 'shengTxt')
      }
    },
    model: {
      value: (_vm.shengTxt),
      callback: function($$v) {
        _vm.shengTxt = $$v
      },
      expression: "shengTxt"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shengIcon),
      expression: "shengIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": false
    }
  }, [_c('grid-item', [_c('popup-radio', {
    attrs: {
      "title": "市",
      "placeholder": "请选择",
      "options": _vm.shiOptions
    },
    on: {
      "on-hide": function($event) {
        _vm.addressChange(_vm.shiTxt, 'divisionOptions', 'shiTxt')
      }
    },
    model: {
      value: (_vm.shiTxt),
      callback: function($$v) {
        _vm.shiTxt = $$v
      },
      expression: "shiTxt"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shiTxtIcon),
      expression: "shiTxtIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": false
    }
  }, [_c('grid-item', [_c('popup-radio', {
    attrs: {
      "readonly": !_vm.lookIf,
      "title": "区/县",
      "placeholder": "请选择",
      "options": _vm.divisionOptions
    },
    on: {
      "on-change": _vm.iftrim
    },
    model: {
      value: (_vm.basedata.divisionId),
      callback: function($$v) {
        _vm.$set(_vm.basedata, "divisionId", $$v)
      },
      expression: "basedata.divisionId"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.divisionIdIcon),
      expression: "divisionIdIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": false
    }
  }, [_c('grid-item', [_c('x-textarea', {
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "title": "详细住址",
      "show-counter": false,
      "rows": 2,
      "autosize": ""
    },
    on: {
      "on-change": _vm.iftrim
    },
    model: {
      value: (_vm.basedata.address),
      callback: function($$v) {
        _vm.$set(_vm.basedata, "address", $$v)
      },
      expression: "basedata.address"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addressIcon),
      expression: "addressIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('group', {
    attrs: {
      "id": "shengaoID",
      "title": "一般情况"
    }
  }, [_c('div', {
    staticClass: "vux-1px-b",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "keyboard": "number",
      "title": "身高(单位cm)",
      "placeholder": "请输入",
      "text-align": "right"
    },
    on: {
      "on-change": _vm.heightType
    },
    model: {
      value: (_vm.objdata.shengao),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "shengao", $$v)
      },
      expression: "objdata.shengao"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shengaoIcon),
      expression: "shengaoIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "title": "体重(单位:Kg)",
      "placeholder": "请输入",
      "text-align": "right"
    },
    on: {
      "on-change": _vm.weightType
    },
    model: {
      value: (_vm.objdata.tizhong),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "tizhong", $$v)
      },
      expression: "objdata.tizhong"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.weightIcon),
      expression: "weightIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1)]), _vm._v(" "), _c('group', {
    attrs: {
      "title": "既往病史"
    }
  }, [_c('cell', {
    attrs: {
      "title": "肝炎"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    model: {
      value: (_vm.objdata.ganyan),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "ganyan", $$v)
      },
      expression: "objdata.ganyan"
    }
  }, _vm._l((_vm.diseaseCommon.ganyanoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "结核"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    model: {
      value: (_vm.objdata.jiehe),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "jiehe", $$v)
      },
      expression: "objdata.jiehe"
    }
  }, _vm._l((_vm.diseaseCommon.jieheoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "肾脏疾病"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    model: {
      value: (_vm.objdata.shenzangjibing),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "shenzangjibing", $$v)
      },
      expression: "objdata.shenzangjibing"
    }
  }, _vm._l((_vm.genifoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "心血管疾病"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    model: {
      value: (_vm.objdata.xinxueguanjibing),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "xinxueguanjibing", $$v)
      },
      expression: "objdata.xinxueguanjibing"
    }
  }, _vm._l((_vm.diseaseCommon.xinxueguanoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "泌尿系统感染"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    model: {
      value: (_vm.objdata.miniaoxitongganran),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "miniaoxitongganran", $$v)
      },
      expression: "objdata.miniaoxitongganran"
    }
  }, _vm._l((_vm.genifoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "性传播疾病史"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    model: {
      value: (_vm.objdata.xingbingchuanbojbs),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "xingbingchuanbojbs", $$v)
      },
      expression: "objdata.xingbingchuanbojbs"
    }
  }, _vm._l((_vm.diseaseCommon.xingjibingoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "阑尾炎"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    model: {
      value: (_vm.objdata.lanweiyan),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "lanweiyan", $$v)
      },
      expression: "objdata.lanweiyan"
    }
  }, _vm._l((_vm.genifoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "盆腔炎"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    on: {
      "on-change": function($event) {
        _vm.radioChoose('penqiangyan', 'penqiangyanbeizhu')
      }
    },
    model: {
      value: (_vm.objdata.penqiangyan),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "penqiangyan", $$v)
      },
      expression: "objdata.penqiangyan"
    }
  }, _vm._l((_vm.genifoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('x-textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.penqiangyanIf),
      expression: "penqiangyanIf"
    }],
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "placeholder": "请详细描述盆腔炎患病情况",
      "show-counter": false,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.objdata.penqiangyanbeizhu),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "penqiangyanbeizhu", $$v)
      },
      expression: "objdata.penqiangyanbeizhu"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "手术史"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    on: {
      "on-change": function($event) {
        _vm.radioChoose('shoushushi', 'shoushushibeizhu')
      }
    },
    model: {
      value: (_vm.objdata.shoushushi),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "shoushushi", $$v)
      },
      expression: "objdata.shoushushi"
    }
  }, _vm._l((_vm.genifoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('x-textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shoushushiIf),
      expression: "shoushushiIf"
    }],
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "placeholder": "请详细描述手术史",
      "show-counter": false,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.objdata.shoushushibeizhu),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "shoushushibeizhu", $$v)
      },
      expression: "objdata.shoushushibeizhu"
    }
  }), _vm._v(" "), _c('x-textarea', {
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "title": "其他病史",
      "placeholder": "请详细描述其他病史",
      "show-counter": false,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.objdata.jiwangbingshiqita),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "jiwangbingshiqita", $$v)
      },
      expression: "objdata.jiwangbingshiqita"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "title": "个人史"
    }
  }, [_c('cell', {
    attrs: {
      "title": "吸烟情况"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    on: {
      "on-change": function($event) {
        _vm.radioChoose('xiyan', 'xiyanzhishu')
      }
    },
    model: {
      value: (_vm.objdata.xiyan),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "xiyan", $$v)
      },
      expression: "objdata.xiyan"
    }
  }, _vm._l((_vm.genifoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('x-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.xiyanIf),
      expression: "xiyanIf"
    }],
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "title": "每天吸多少支烟？",
      "keyboard": "number",
      "type": "number",
      "text-align": "right",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.objdata.xiyanzhishu),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "xiyanzhishu", $$v)
      },
      expression: "objdata.xiyanzhishu"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "酗酒"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    model: {
      value: (_vm.objdata.xujiu),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "xujiu", $$v)
      },
      expression: "objdata.xujiu"
    }
  }, _vm._l((_vm.genifoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "吸毒"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    model: {
      value: (_vm.objdata.xidu),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "xidu", $$v)
      },
      expression: "objdata.xidu"
    }
  }, _vm._l((_vm.genifoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "重大精神刺激史"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    on: {
      "on-change": function($event) {
        _vm.radioChoose('zhongdajingshencijishi', 'zhongdajingshencijishibz')
      }
    },
    model: {
      value: (_vm.objdata.zhongdajingshencijishi),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "zhongdajingshencijishi", $$v)
      },
      expression: "objdata.zhongdajingshencijishi"
    }
  }, _vm._l((_vm.genifoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('x-textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.zhongdajingshencijishiIf),
      expression: "zhongdajingshencijishiIf"
    }],
    attrs: {
      "readonly": !_vm.lookIf,
      "placeholder": "请详细描述重大精神刺激史",
      "show-counter": false,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.objdata.zhongdajingshencijishibz),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "zhongdajingshencijishibz", $$v)
      },
      expression: "objdata.zhongdajingshencijishibz"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "习惯用药"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    on: {
      "on-change": function($event) {
        _vm.radioChoose('xiguanyongyao', 'xiguanyongyaobz')
      }
    },
    model: {
      value: (_vm.objdata.xiguanyongyao),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "xiguanyongyao", $$v)
      },
      expression: "objdata.xiguanyongyao"
    }
  }, _vm._l((_vm.genifoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('x-textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.xiguanyongyaoIf),
      expression: "xiguanyongyaoIf"
    }],
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "placeholder": "请详细描述习惯用药",
      "show-counter": false,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.objdata.xiguanyongyaobz),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "xiguanyongyaobz", $$v)
      },
      expression: "objdata.xiguanyongyaobz"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "药物过敏史"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    on: {
      "on-change": function($event) {
        _vm.radioChoose('yaowuguominshi', 'yaowuguominshibeizhu')
      }
    },
    model: {
      value: (_vm.objdata.yaowuguominshi),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "yaowuguominshi", $$v)
      },
      expression: "objdata.yaowuguominshi"
    }
  }, _vm._l((_vm.genifoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('x-textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.yaowuguominshiIf),
      expression: "yaowuguominshiIf"
    }],
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "placeholder": "请详细描述药物过敏史",
      "show-counter": false,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.objdata.yaowuguominshibeizhu),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "yaowuguominshibeizhu", $$v)
      },
      expression: "objdata.yaowuguominshibeizhu"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "出生缺陷"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    on: {
      "on-change": function($event) {
        _vm.radioChoose('chushenquexian', 'chushengquexianbeizhu')
      }
    },
    model: {
      value: (_vm.objdata.chushenquexian),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "chushenquexian", $$v)
      },
      expression: "objdata.chushenquexian"
    }
  }, _vm._l((_vm.genifoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('x-textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chushenquexianIf),
      expression: "chushenquexianIf"
    }],
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "placeholder": "请详细描述出生缺陷",
      "show-counter": false,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.objdata.chushengquexianbeizhu),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "chushengquexianbeizhu", $$v)
      },
      expression: "objdata.chushengquexianbeizhu"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "过去的健康状况"
    }
  }), _vm._v(" "), _c('checker', {
    staticClass: "checkClass",
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    model: {
      value: (_vm.objdata.jiankangguoqu),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "jiankangguoqu", $$v)
      },
      expression: "objdata.jiankangguoqu"
    }
  }, _vm._l((_vm.jiankangoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  })), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "现在的健康状况"
    }
  }), _vm._v(" "), _c('checker', {
    staticClass: "checkClass",
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    model: {
      value: (_vm.objdata.jiangkangxianzai),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "jiangkangxianzai", $$v)
      },
      expression: "objdata.jiangkangxianzai"
    }
  }, _vm._l((_vm.jiankangoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('group', {
    attrs: {
      "id": "yuejingshiID",
      "title": "月经史"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "keyboard": "number",
      "label-width": "200px",
      "title": "第一次来月经是多少岁？",
      "text-align": "right",
      "placeholder": "请输入"
    },
    on: {
      "on-change": function($event) {
        _vm.noxiaoshuType('chuchao', true)
      }
    },
    model: {
      value: (_vm.objdata.chuchao),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "chuchao", $$v)
      },
      expression: "objdata.chuchao"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.chuchaoIcon),
      expression: "iconArry.chuchaoIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "label-width": "200px",
      "keyboard": "number",
      "title": "每次月经来多少天？",
      "text-align": "right",
      "placeholder": "请输入"
    },
    on: {
      "on-change": function($event) {
        _vm.noxiaoshuType('yuejingtianshu', false)
      }
    },
    model: {
      value: (_vm.yuejingtianshu),
      callback: function($$v) {
        _vm.yuejingtianshu = $$v
      },
      expression: "yuejingtianshu"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.yuejingtianshuIcon),
      expression: "iconArry.yuejingtianshuIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "label-width": "200px",
      "keyboard": "number",
      "title": "每次月经周期间隔天？",
      "text-align": "right",
      "placeholder": "请输入"
    },
    on: {
      "on-change": function($event) {
        _vm.noxiaoshuType('yuejingzhouqijiange', false)
      }
    },
    model: {
      value: (_vm.yuejingzhouqijiange),
      callback: function($$v) {
        _vm.yuejingzhouqijiange = $$v
      },
      expression: "yuejingzhouqijiange"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.yuejingzhouqijiangeIcon),
      expression: "iconArry.yuejingzhouqijiangeIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "经量"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    model: {
      value: (_vm.objdata.jingliang),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "jingliang", $$v)
      },
      expression: "objdata.jingliang"
    }
  }, _vm._l((_vm.jingliangOptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "痛经"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    model: {
      value: (_vm.objdata.tongjing),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "tongjing", $$v)
      },
      expression: "objdata.tongjing"
    }
  }, _vm._l((_vm.genifoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1)], 1), _vm._v(" "), _c('group', {
    attrs: {
      "id": "hunyushiID",
      "title": "婚育史"
    }
  }, [_c('cell', {
    attrs: {
      "title": "近亲结婚(三代以内有共同的血缘关系)"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    model: {
      value: (_vm.objdata.jinqinjiehun),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "jinqinjiehun", $$v)
      },
      expression: "objdata.jinqinjiehun"
    }
  }, _vm._l((_vm.genyesoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "再婚"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    model: {
      value: (_vm.objdata.zaihun),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "zaihun", $$v)
      },
      expression: "objdata.zaihun"
    }
  }, _vm._l((_vm.genyesoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "妊娠"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    on: {
      "on-change": function($event) {
        _vm.radioChoose('renshen', 'mocirenshendate')
      }
    },
    model: {
      value: (_vm.objdata.renshen),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "renshen", $$v)
      },
      expression: "objdata.renshen"
    }
  }, _vm._l((_vm.genyesoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('datetime', {
    attrs: {
      "readonly": !_vm.lookIf,
      "format": "YYYY-MM",
      "title": "末次妊娠时间"
    },
    model: {
      value: (_vm.mocirenshendate),
      callback: function($$v) {
        _vm.mocirenshendate = $$v
      },
      expression: "mocirenshendate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "title": "人工流产次数",
      "keyboard": "number",
      "text-align": "right",
      "placeholder": "请输入"
    },
    on: {
      "on-change": function($event) {
        _vm.noxiaoshuType('rengongliuchan', true, 'ziranliuchan')
      }
    },
    model: {
      value: (_vm.objdata.rengongliuchan),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "rengongliuchan", $$v)
      },
      expression: "objdata.rengongliuchan"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.rengongliuchanIcon),
      expression: "iconArry.rengongliuchanIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-input', {
    ref: "ziranliuchan",
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "title": "自然流产次数",
      "keyboard": "number",
      "text-align": "right",
      "placeholder": "请输入"
    },
    on: {
      "on-change": function($event) {
        _vm.noxiaoshuType('ziranliuchan', true, 'yaoliu')
      }
    },
    model: {
      value: (_vm.objdata.ziranliuchan),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "ziranliuchan", $$v)
      },
      expression: "objdata.ziranliuchan"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.ziranliuchanIcon),
      expression: "iconArry.ziranliuchanIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-input', {
    ref: "yaoliu",
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "title": "药流次数",
      "keyboard": "number",
      "text-align": "right",
      "placeholder": "请输入"
    },
    on: {
      "on-change": function($event) {
        _vm.noxiaoshuType('yaoliu', true, 'yinchan')
      }
    },
    model: {
      value: (_vm.objdata.yaoliu),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "yaoliu", $$v)
      },
      expression: "objdata.yaoliu"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.yaoliuIcon),
      expression: "iconArry.yaoliuIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-input', {
    ref: "yinchan",
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "title": "引产次数",
      "keyboard": "number",
      "text-align": "right",
      "placeholder": "请输入"
    },
    on: {
      "on-change": function($event) {
        _vm.noxiaoshuType('yinchan', true, 'zaochan')
      }
    },
    model: {
      value: (_vm.objdata.yinchan),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "yinchan", $$v)
      },
      expression: "objdata.yinchan"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.yinchanIcon),
      expression: "iconArry.yinchanIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-input', {
    ref: "zaochan",
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "title": "早产次数",
      "keyboard": "number",
      "text-align": "right",
      "placeholder": "请输入"
    },
    on: {
      "on-change": function($event) {
        _vm.noxiaoshuType('zaochan', true, 'gongwaiyunzuo')
      }
    },
    model: {
      value: (_vm.objdata.zaochan),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "zaochan", $$v)
      },
      expression: "objdata.zaochan"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.zaochanIcon),
      expression: "iconArry.zaochanIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-input', {
    ref: "gongwaiyunzuo",
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "title": "左边宫外孕次数",
      "keyboard": "number",
      "text-align": "right",
      "placeholder": "请输入"
    },
    on: {
      "on-change": function($event) {
        _vm.noxiaoshuType('gongwaiyunzuo', true, 'gongwaiyunyou')
      }
    },
    model: {
      value: (_vm.objdata.gongwaiyunzuo),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "gongwaiyunzuo", $$v)
      },
      expression: "objdata.gongwaiyunzuo"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.gongwaiyunzuoIcon),
      expression: "iconArry.gongwaiyunzuoIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-input', {
    ref: "gongwaiyunyou",
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "title": "右边宫外孕次数",
      "keyboard": "number",
      "text-align": "right",
      "placeholder": "请输入"
    },
    on: {
      "on-change": function($event) {
        _vm.noxiaoshuType('gongwaiyunyou', true, 'zuyuechan')
      }
    },
    model: {
      value: (_vm.objdata.gongwaiyunyou),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "gongwaiyunyou", $$v)
      },
      expression: "objdata.gongwaiyunyou"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.gongwaiyunyouIcon),
      expression: "iconArry.gongwaiyunyouIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-input', {
    ref: "zuyuechan",
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "title": "足月产次数",
      "keyboard": "number",
      "text-align": "right",
      "placeholder": "请输入"
    },
    on: {
      "on-change": function($event) {
        _vm.noxiaoshuType('zuyuechan', true, 'poufuchan')
      }
    },
    model: {
      value: (_vm.objdata.zuyuechan),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "zuyuechan", $$v)
      },
      expression: "objdata.zuyuechan"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.zuyuechanIcon),
      expression: "iconArry.zuyuechanIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-input', {
    ref: "poufuchan",
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "title": "剖腹产次数",
      "keyboard": "number",
      "text-align": "right",
      "placeholder": "请输入"
    },
    on: {
      "on-change": function($event) {
        _vm.noxiaoshuType('poufuchan', true, 'shunchan')
      }
    },
    model: {
      value: (_vm.objdata.poufuchan),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "poufuchan", $$v)
      },
      expression: "objdata.poufuchan"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.poufuchanIcon),
      expression: "iconArry.poufuchanIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-input', {
    ref: "shunchan",
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "title": "顺产次数",
      "keyboard": "number",
      "text-align": "right",
      "placeholder": "请输入"
    },
    on: {
      "on-change": function($event) {
        _vm.noxiaoshuType('shunchan', true, 'xianyouzinv')
      }
    },
    model: {
      value: (_vm.objdata.shunchan),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "shunchan", $$v)
      },
      expression: "objdata.shunchan"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.shunchanIcon),
      expression: "iconArry.shunchanIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-input', {
    ref: "xianyouzinv",
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "title": "现有子女人数",
      "keyboard": "number",
      "text-align": "right",
      "placeholder": "请输入"
    },
    on: {
      "on-change": function($event) {
        _vm.noxiaoshuType('xianyouzinv', true)
      }
    },
    model: {
      value: (_vm.objdata.xianyouzinv),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "xianyouzinv", $$v)
      },
      expression: "objdata.xianyouzinv"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconArry.xianyouzinvIcon),
      expression: "iconArry.xianyouzinvIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "是否领养子女"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    on: {
      "on-change": function($event) {
        _vm.radioChoose('lingyangzinv', 'lingyangzinvsl')
      }
    },
    model: {
      value: (_vm.objdata.lingyangzinv),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "lingyangzinv", $$v)
      },
      expression: "objdata.lingyangzinv"
    }
  }, _vm._l((_vm.genyesoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('x-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lingyangzinvIf),
      expression: "lingyangzinvIf"
    }],
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "title": "领养子女人数",
      "keyboard": "number",
      "text-align": "right",
      "placeholder": "请输入"
    },
    on: {
      "on-change": function($event) {
        _vm.noxiaoshuType('lingyangzinvsl', true)
      }
    },
    model: {
      value: (_vm.objdata.lingyangzinvsl),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "lingyangzinvsl", $$v)
      },
      expression: "objdata.lingyangzinvsl"
    }
  }), _vm._v(" "), _c('x-textarea', {
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "title": "其他婚育病史",
      "placeholder": "请输入",
      "show-counter": false,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.objdata.hunyushiqita),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "hunyushiqita", $$v)
      },
      expression: "objdata.hunyushiqita"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "title": "家族病史"
    }
  }, [_c('cell', {
    attrs: {
      "title": "遗传病史"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    on: {
      "on-change": function($event) {
        _vm.radioChoose('yichuanbingshi', 'yichuanbingshibeizhu')
      }
    },
    model: {
      value: (_vm.objdata.yichuanbingshi),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "yichuanbingshi", $$v)
      },
      expression: "objdata.yichuanbingshi"
    }
  }, _vm._l((_vm.genifoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('x-textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.yichuanbingshiIf),
      expression: "yichuanbingshiIf"
    }],
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "placeholder": "请详细描述遗传病史",
      "show-counter": false,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.objdata.yichuanbingshibeizhu),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "yichuanbingshibeizhu", $$v)
      },
      expression: "objdata.yichuanbingshibeizhu"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "不孕不育病史"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    on: {
      "on-change": function($event) {
        _vm.radioChoose('buyunbuyu', 'buyunbuyubeizhu')
      }
    },
    model: {
      value: (_vm.objdata.buyunbuyu),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "buyunbuyu", $$v)
      },
      expression: "objdata.buyunbuyu"
    }
  }, _vm._l((_vm.genifoptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "disabled": !_vm.lookIf,
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('x-textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buyunbuyuIf),
      expression: "buyunbuyuIf"
    }],
    staticClass: "inputClick",
    attrs: {
      "readonly": !_vm.lookIf,
      "placeholder": "请详细描述不孕不育病史",
      "show-counter": false,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.objdata.buyunbuyubeizhu),
      callback: function($$v) {
        _vm.$set(_vm.objdata, "buyunbuyubeizhu", $$v)
      },
      expression: "objdata.buyunbuyubeizhu"
    }
  })], 1), _vm._v(" "), (_vm.lookIf) ? _c('flexbox', {
    staticClass: "btnGroup"
  }, [_c('flexbox-item', [_c('x-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.submitDisable
    },
    nativeOn: {
      "click": function($event) {
        _vm.sureClick($event)
      }
    }
  }, [_vm._v("提 交")])], 1), _vm._v(" "), _c('flexbox-item', [_c('x-button', {
    attrs: {
      "type": "default"
    },
    nativeOn: {
      "click": function($event) {
        _vm.colse($event)
      }
    }
  }, [_vm._v("取 消")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('toast', {
    attrs: {
      "type": "text",
      "time": 800,
      "is-show-mask": "",
      "text": _vm.toastTxt,
      "position": "middle"
    },
    model: {
      value: (_vm.toastShow),
      callback: function($$v) {
        _vm.toastShow = $$v
      },
      expression: "toastShow"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('popup', {
    staticClass: "checker-popup",
    model: {
      value: (_vm.showPopup),
      callback: function($$v) {
        _vm.showPopup = $$v
      },
      expression: "showPopup"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 10px 40px 10px"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "trade-item",
      "selected-item-class": "trade-item-selected",
      "disabled-item-class": "trade-item-disabled"
    },
    model: {
      value: (_vm.trade),
      callback: function($$v) {
        _vm.trade = $$v
      },
      expression: "trade"
    }
  }, _vm._l((_vm.tradeData), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "value": item.id
      },
      on: {
        "on-item-click": function($event) {
          _vm.showPopup = false
        }
      }
    }, [_vm._v(" " + _vm._s(item.tagName) + " ")])
  }))], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd1443ea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/perfectMessageProject/perfectMessageWoman.vue
// module id = 9Pr8
// module chunks = 5